import { useState } from 'react';
import { getPath } from '../../utils/ncfReviewRoot.js';

export default function NcfSameAsManager({ root, disabled, onCopy }) {
  const [copied, setCopied] = useState(false);
  const managerName = String(getPath(root, 'jobdiva.job.managerName')).trim();
  const managerEmail = String(getPath(root, 'jobdiva.job.managerEmail')).trim();
  const available = Boolean(managerName && managerEmail);
  const matches = getPath(root, 'jobdiva.job.timesheetApproverName') === managerName
    && getPath(root, 'jobdiva.job.timesheetApproverEmail') === managerEmail;

  return <label className="ncf-same-as-manager" title={available ? undefined : 'Enter the manager name and email first.'}>
    <input type="checkbox" checked={copied && matches} disabled={disabled || !available} onChange={event => {
      setCopied(event.target.checked);
      if (event.target.checked) onCopy({
        'jobdiva.job.timesheetApproverName': managerName,
        'jobdiva.job.timesheetApproverEmail': managerEmail
      });
    }} />
    Same as manager
  </label>;
}
